import type { ComponentClass, FunctionComponent, JSX } from 'react'
import type { RouterResponse } from '~/core/router'

import { createElement, memo } from 'react'
import { isArray } from '~/shared/helpers'

interface Props {
  route: RouterResponse | undefined
}

AppPage.displayName = 'Page'
function AppPage({ route }: Props): JSX.Element | null {
  if (!route || !route.component) return null
  return (
    <>
      {isArray(route.component)
        ? route.component.map((c, i) => render(c, route.props, i))
        : render(route.component, route.props)}
    </>
  )
}

export const Page = memo(AppPage)

/**
 * Creates page single component, using `displayName` as a key
 */
function render(
  component?: FunctionComponent<any> | ComponentClass<any, any>,
  props?: any,
  i?: number
) {
  if (!component) return null
  const key = `${component.displayName || component.name}-${i ?? ''}`
  return createElement(component, { key, ...props })
}
